/**
 * AuthDialog Component
 *
 * Supabase Auth UI widget, themed to match the game's Art Deco palette.
 * Supports sign in, sign up, Google OAuth, and password reset.
 * Rendered inside LoginBoard's door rectangle.
 */

import { Auth } from '@supabase/auth-ui-react';
import { ThemeSupa } from '@supabase/auth-ui-shared';
import { supabase } from '../../lib/supabase';
import styles from './AuthDialog.module.css';

const AuthDialog: React.FC = () => {
  return (
    <div className={styles.authCard}>
      <p className={styles.tagline}>
        A new daily puzzle game, coming soon.<br />
        Beta players log in below.
      </p>
      <Auth
        supabaseClient={supabase}
        appearance={{
          theme: ThemeSupa,
          variables: {
            default: {
              colors: {
                brand: '#514b44',
                brandAccent: '#635b52',
                brandButtonText: '#f7e5c5',
                defaultButtonBackground: '#3a3a3a',
                defaultButtonBackgroundHover: '#4a4a4a',
                defaultButtonBorder: '#4a4a4a',
                defaultButtonText: '#f7e5c5',
                dividerBackground: '#3a3a3a',
                inputBackground: '#1a1a1a',
                inputBorder: '#4a4a4a',
                inputBorderHover: '#514b44',
                inputBorderFocus: '#514b44',
                inputPlaceholder: '#777',
                inputText: '#f7e5c5',
                inputLabelText: '#f7e5c5',
                messageText: '#a89880',
                messageTextDanger: '#b64624',
                anchorTextColor: '#a89880',
                anchorTextHoverColor: '#f7e5c5',
              },
              fonts: {
                bodyFontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
                buttonFontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
                inputFontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
                labelFontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
              },
              fontSizes: {
                baseBodySize: '1em',
                baseButtonSize: '1em',
                baseInputSize: '1em',
                baseLabelSize: '0.93em',
              },
              borderWidths: {
                buttonBorderWidth: '1px',
                inputBorderWidth: '1px',
              },
              radii: {
                borderRadiusButton: '0.4em',
                buttonBorderRadius: '0.4em',
                inputBorderRadius: '0.4em',
              },
              space: {
                inputPadding: '0.85em',
                buttonPadding: '0.85em 1.1em',
              },
            },
          },
          className: {
            container: styles.authContainer,
          },
        }}
        providers={['google']}
        redirectTo={window.location.origin}
        view="sign_in"
        showLinks={true}
        localization={{
          variables: {
            sign_in: {
              email_label: 'Email',
              password_label: 'Password',
              button_label: 'Sign In',
            },
            sign_up: {
              email_label: 'Email',
              password_label: 'Password',
              button_label: 'Sign Up',
            },
            forgotten_password: {
              email_label: 'Email',
              button_label: 'Send Reset Link',
            },
          },
        }}
      />
    </div>
  );
};

export default AuthDialog;
